import React from "react";
import { Card, Progress } from "reactstrap";
import { Bell, ChevronRight } from "react-feather";
import { Link } from "react-router-dom";
import { routes } from "../../../routes/routes";

interface IProductActionsCardProps {
    notificationsCount: number;
    totalActions: number;
    actionsPendingCount: number;
}

const ProductActionsCard: React.FC<IProductActionsCardProps> = ({
    notificationsCount,
    totalActions,
    actionsPendingCount
}) => {
    const progress = totalActions > 0 ? (notificationsCount / totalActions) * 100 : 0;

    return (
        <Card className="product-actions-card border-0 shadow-sm h-100">
            <div className="card-content-wrapper p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                        <div className="icon-wrapper mr-2">
                            <Bell size={20} />
                        </div>
                        <h5 className="mb-0 font-weight-bold" style={{ color: "#334155" }}>Product Actions</h5>
                    </div>
                    <div className="badge badge-light px-2 py-1 text-muted" style={{ backgroundColor: "#f1f5f9" }}>
                        {notificationsCount}/{totalActions}
                    </div>
                </div>

                <div className="mb-4">
                    <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted small">Progress</span>
                        <span className="text-muted small font-weight-bold">{Math.round(progress)}%</span>
                    </div>
                    <Progress value={progress} className="action-progress-bar" />
                </div>

                <div className="action-items">
                    <div className="action-item mb-3 p-3 rounded d-flex justify-content-between align-items-center notification-item">
                        <div className="d-flex align-items-center">
                            <div className="count-circle mr-3">{notificationsCount}</div>
                            <span className="font-weight-bold">Notifications Pending</span>
                        </div>
                        <Link to={routes.NOTIFICATIONS} className="view-all-link small">
                            View all <ChevronRight size={14} />
                        </Link>
                    </div>

                    <div className="action-item p-3 rounded d-flex justify-content-between align-items-center action-pending-item">
                        <div className="d-flex align-items-center">
                            <div className="count-circle mr-3">{actionsPendingCount}</div>
                            <span className="font-weight-bold">Actions Pending</span>
                        </div>
                        <Link to={routes.NOTIFICATIONS} className="view-all-link small">
                            View all <ChevronRight size={14} />
                        </Link>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProductActionsCard;
